import DepsService from 'services/dependencies';

const CONTEXT = 'twoFactor';

export const fetchTwoFactorSetup = () => {
  const { url } = DepsService.rest.auth.twoFactor.setup;

  return DepsService.restSrv.get(CONTEXT, url);
};

export const confirmTwoFactorCode = (queryParams) => {
  const { url } = DepsService.rest.auth.twoFactor.confirm;

  return DepsService.restSrv.create(CONTEXT, url, queryParams);
};



// WEBPACK FOOTER //
// ./src/modules/auth/resources/two-factor.api.js